<template>
  <div id="questionFault">
    <div class="systerm-classity">
      <span :class="{'active':officialAccessories=='1'}" @click="handleClickTab('1')">非官方部件</span>
      <span :class="{'active':officialAccessories=='2'}" @click="handleClickTab('2')">官方部件</span>
       <span :class="{'active':officialAccessories=='0'}" @click="handleClickTab('0')">更换整机</span>
    </div>
    <div class="brand container">
      <h4>故障大类</h4>
      <ul class="clearfix">
        <li
          v-for="(item,index) in faultClassLists"
          :key="index"
          class="faultClassListPart listPart"
          @click="selectFaultClass(item,index)"
        >
          {{item.faultTypesName}}
          <span v-bind:class="{active:activeIndex===index}">
            <i class="el-icon-check"></i>
          </span>
        </li>
      </ul>
    </div>
    <template v-if="modelClassList && modelClassList.length >0">
      <div class="brand container">
        <h4>型号</h4>
        <ul class="clearfix">
          <li
            v-for="(item,index) in modelClassList"
            :key="index+item"
            class="faultClassListPart listPart"
            @click="selectModel(item,index)"
          >
            {{item.modelName}}
            <span v-bind:class="{active:modelActiveIndex===index}">
              <i class="el-icon-check"></i>
            </span>
          </li>
        </ul>
      </div>
    </template>
    <template v-if="isShowQuestion">
      <div class="question container">
        <h4>问题/图片</h4>
        <ul class="clearfix">
          <li v-if="!isShowAdd" class="faultClassListPart listPart">
            <p>{{questionList.particularsProblem}}</p>
            <span>
              <span class="exitBtn" @click.stop="exitFault()">编辑</span>
              <i
                class="el-icon-error activeDelBtn"
                @click.stop="deleFault()"
                v-if="fauleAuth.deleFault"
              ></i>
            </span>
          </li>
          <li v-else class="addContent" @click="addNewQuestion()">
            <i class="el-icon-plus"></i>
          </li>
        </ul>
        <el-dialog
          :title="textMenu[dialogMenuStatus]"
          :visible.sync="dislogBrand"
          :close-on-click-modal="false"
          width="600px"
          @close="emptyDialog('brandForm')"
        >
          <el-form :model="ruleForm" ref="ruleForm" label-width="100px">
            <el-form-item label="故障分类">{{questionType}}</el-form-item>
            <el-form-item label="问答">
              <el-select v-model="ruleForm.answer" placeholder="请选择" multiple>
                <el-option
                  v-for="item in allQuestionList"
                  :key="item.id"
                  :label="item.questionName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="请选择图片">
              <el-select v-model="ruleForm.images" placeholder="请选择" multiple>
                <el-option
                  v-for="item in picList"
                  :key="item.id"
                  :label="item.imageName"
                  :value="item.id"
                  class="special-item"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <div class="pic-list">
                <img :src="item" class="pic" v-for="(item,index) in imageList" :key="item+index" />
              </div>
            </el-form-item>
            <el-form-item>
              <el-button @click="handleCancelDialog('ruleForm')" size="small">取 消</el-button>
              <el-button type="primary" @click="handleSubmit('ruleForm')" size="small">保 存</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </div>
    </template>
  </div>
</template>

<script>
import store from "../../store/store";
import { genUpToken } from "./com/qiniuToken.js";
import { getPermission } from "../../api/authRequest";
import { addPaticularQuestion, getAllInfoImage } from "../../api/system";
import {
  selectfaultTypes,
  resonFaultGetModel,
  getQuestionList,
  getAllquestionList,
  allPicture
} from "../../api/api";
export default {
  name: "questionFault",
  data() {
    return {
      picList: [],
      value: "",
      dislogBrand: false,
      activeIndex: 0,
      modelActiveIndex: "",
      questionActiveIndex: "",
      faultClassLists: [], //故障大类分类列表
      modelClassList: [], //手机型号分类列表
      questionList: {}, //问题列表
      faultTypesId: "", //故障大类id
      modelId: "", // 型号id
      nowQuestionId: "", //当前问题id
      dislogBrand: false,
      allPictureLis: [],
      isShowAdd: false,

      propImg: "", //弹框需要展示图片
      fauleAuth: {
        newQuestion: false,
        exitFaultClass: true,
        deleFaultClass: true
      },
      dialogMenuStatus: "",
      textMenu: {
        update: "修改问题/图片",
        create: "新增问题/图片"
      },
      questionType: "",
      ruleForm: {
        answer: [],
        intro: "",
        images: []
      },
      rules: {
        name: [
          { required: true, message: "请输入名称", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ],
        question: [
          { required: true, message: "请输入问题", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ]
      },
      selectDefault: "",
      allQuestionList: [], //所有问题列表
      imageUrl: "",
      isShowQuestion: false,
      imageList: [],
      officialAccessories: "1",
      listQuestionId: ""
    };
  },
  watch: {
    ruleForm: {
      handler(newVlaue, oldValue) {
        if (newVlaue.images) {
          this.imageList = [];
          for (let i = 0; i < this.picList.length; i++) {
            let rs = this.picList && this.picList[i].id;
            if (newVlaue.images.indexOf(rs) != -1) {
              this.imageList.push(this.picList[i].imageUrl);
            }
          }
        }
      },
      deep: true
    }
  },
  created() {
    this.getDefaultClass();
    this.getAllInfoImage();
    this.getAllQuestionListData();
  },
  mounted() {
    this.fauleAuth.newQuestion = getPermission(
      "/api/basicSetting/paticulars/add_paticulars"
    );
  },
  methods: {
    handleClickTab(tabId) {
      this.officialAccessories = tabId;
      this.ruleForm = {
        intro: "",
        images: [],
        answer: []
      };
    },
    emptyDialog() {
      this.ruleForm = {
        intro: "",
        images: [],
        answer: []
      };
    },
    //获取图片列表
    getAllInfoImage() {
      getAllInfoImage({}).then(res => {
        this.picList = res.data.results;
      });
    },
    //问题提交
    handleSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = {
            modelId: this.modelId,
            faultTypesId: this.faultTypesId,
            questionId: this.ruleForm.answer,
            imagesId: this.ruleForm.images,
            officialAccessories: this.officialAccessories
          };
          addPaticularQuestion(params).then(res => {
            this.dislogBrand = false;
              if (res.data.status == 100) {
                this.$message({
                  message: res.data.message,
                  type: "success"
                });
                this.ruleForm = {
                  intro: "",
                  images: [],
                  answer: []
                };
                //刷新列表
                this.getQuestionListData();
              } else {
                this.ruleForm = {
                  intro: "",
                  images: [],
                  answer: []
                };
                this.$message({
                  message: res.data.message,
                  type: "error"
                });
              }
          });
        } else {
          return false;
        }
      });
    },
    //取消提问
    handleCancelDialog(formName) {
      this.dislogBrand = false;
      this.ruleForm = {
        intro: "",
        images: [],
        answer: []
      };
    },
    //获取故障列表
    getDefaultClass() {
      selectfaultTypes().then(res => {
        this.faultClassLists = res.data.results;
        this.faultTypesId = this.faultClassLists[0].faultTypesId;
        this.questionType = this.faultClassLists[0].faultTypesName;
        this.getDefaultSelectBrand();
      });
    },
    //选择故障分类
    selectFaultClass(item, index) {
      this.activeIndex = index;
      this.FaultClassForm = Object.assign({}, item);
      this.faultTypesId = this.FaultClassForm.faultTypesId;
      this.questionType = this.FaultClassForm.faultTypesName;
      this.getDefaultSelectBrand();
    },
    //根据故障大类查询型号列表
    getDefaultSelectBrand() {
      let faultTypesId = this.faultTypesId;
      resonFaultGetModel({ faultTypesId: faultTypesId }).then(res => {
        this.modelClassList = res.data.results;
      });
    },
    //选择型号
    selectModel(item, index) {
      this.modelActiveIndex = index;
      this.ModelClassForm = Object.assign({}, item);
      this.modelId = this.ModelClassForm.modelId;
      this.getQuestionListData();
      this.isShowQuestion = true;
    },
    //查询所有图片信息
    getAllpictureData() {
      let params = {
        faultTypesId: this.faultTypesId,
        modelId: this.modelId,
        state: "1"
      };
      allPicture(params).then(res => {
        console.log(res, "tupiansuoyou");
        this.allPictureLis = res.data.results;
      });
    },
    //根据型号获取问题列表
    getQuestionListData() {
      let params = {
        faultTypesId: this.faultTypesId,
        officialAccessories: this.officialAccessories, //1不是官方配件描述，2官方配件描述
        modelId: this.modelId
      };
      getQuestionList(params).then(res => {
        console.log(res.data.results[0]);
        if (res.data.results.length > 0) {
          this.isShowAdd = false;
          this.questionList = res.data.results[0];
          console.log(this.questionList, "fuzhi");
        } else {
          this.isShowAdd = true;
        }
      });
    },
    //选择问题、图片
    selectQuestion(item, index) {
      this.questionActiveIndex = index;
    },
    // 添加故障
    addNewQuestion() {
      this.dialogMenuStatus = "create";
      this.dislogBrand = true;
    },
    //获取所有问题列表
    getAllQuestionListData() {
      getAllquestionList({}).then(res => {
        this.allQuestionList = res.data.results;
      });
    },
    // 编辑问题图片
    exitFault() {
      this.listQuestionId = this.questionList.id;
      let params1 = {
        faultTypesId: this.faultTypesId,
        modelId: this.modelId,
        state: "1",
        officialAccessories: this.officialAccessories
      };
      let params2 = {
        faultTypesId: this.faultTypesId,
        officialAccessories: this.officialAccessories, //1不是官方配件描述，2官方配件描述
        modelId: this.modelId
      };
      getQuestionList(params2).then(res => {
        if (res.data.results.length > 0) {
          let questionList = res.data.results;
          allPicture(params1).then(res => {
            let allPictureLis = res.data.results;
            this.dialogMenuStatus = "update";
            this.dislogBrand = true;
            this.ruleForm.answer = questionList.map(item => {
              return item.questionId;
            });
            this.ruleForm.images = allPictureLis.map(item => {
              return item.imageId;
            });
          });
        }
      });
    },
    //删除品牌
    deleBrand(item) {
      this.brandForm = Object.assign({}, item);
      this.$confirm("确认删除该品牌?", "提示", {
        type: "warning"
      })
        .then(() => {
          const brandId = this.brandForm.brandId;
          const brandData = { brandId: brandId };
          deleteBrand(brandData)
            .then(res => {
              if (res.data.status == 100) {
                this.$message({
                  message: res.data.message,
                  type: "success"
                });
                /*刷新列表*/
                this.getBrandLists();
                this.activeIndex = 0;
              } else {
                this.$message({
                  message: res.data.message,
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.$Message.error(error.message);
            });
        })
        .catch(() => {});
    }
  }
};
</script>

<style  lang="scss" type="text/css" scoped>
// /deep/ .el-icon-check:before {
//   content: "";
// }
.pic-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .pic {
    width: 100px;
    height: 100px;
    margin: 10px 0 0 10px;
  }
}
#questionFault {
  .clearfix {
    clear: both;
    overflow: hidden;
  }
  .systerm-classity {
    background: #f3f6fc;
    padding: 15px 0 15px 25px;
    box-sizing: border-box;

    span {
      width: 130px;
      height: 30px;
      line-height: 28px;
      background: #ffffff;
      padding: 3px 9px;
      border-radius: 5px;
      display: inline-block;
      box-sizing: border-box;
      text-align: center;
      cursor: pointer;
    }
    .active {
      color: #fff;
      background: #409eff;
    }
  }

  .container {
    border-bottom: 1px solid #c6c6c6;
    padding-bottom: 20px;
    h4 {
      margin: 15px 0;
      font-weight: 500;
      font-size: 16px;
    }
    .listPart {
      width: 160px;
      float: left;
      border: 1px solid #10c55b;
      margin: 0 15px 10px 0;
      border-radius: 10px;
      min-height: 20px;
      line-height: 1.8;
      padding: 20px 0 20px;
      text-align: center;
      position: relative;
      z-index: 0;
      cursor: pointer;
      font-size: 13px;
      & > span:first-child {
        display: none;
      }
      p {
        width: 160px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 2.8;
        text-align: center;
        font-size: 13px;
      }
      span.active {
        position: absolute;
        top: -1px;
        right: -1px;
        display: block;
        width: 30px;
        height: 30px;
        border-width: 16px;
        border-style: solid;
        border-color: #1abc9c #1abc9c #fff #fff;
        border-top-right-radius: 10px;
        i {
          position: absolute;
          font-size: 14px;
          color: #fff;
          top: -9px;
        }
      }
      span.exitBtn {
        position: absolute;
        bottom: 0;
        width: 100%;
        line-height: 20px;
        left: 0;
        border-top: 1px solid #10c55b;
        z-index: 1;
        display: block;
        background-color: #d7ffe8;
        border-radius: 0 0 10px 10px;
        color: #10c55b;
      }
      i.activeDelBtn {
        display: none;
        position: absolute;
        top: 5px;
        left: 5px;
        color: #e03b5b;
      }
    }
    .listPart:hover {
      box-shadow: 2px 2px 2px #c6c6c6;
    }
    .listPart:hover span.exitBtn {
      display: block;
    }
    .listPart:hover i.activeDelBtn {
      display: block;
    }
    .addContent {
      border: 1px dashed #c6c6c6;
      width: 50px;
      height: 50px;
      line-height: 50px;
      float: left;
      text-align: center;
      margin-top: 15px;
      cursor: pointer;
      i {
        font-size: 20px;
      }
    }
    .contentPart {
      width: 80px;
      float: left;
      border: 1px solid #c6c6c6;
      margin: 0 15px 10px 0;
      border-radius: 5px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      position: relative;
      z-index: 0;
      cursor: pointer;
    }
    .activeContent {
      background-color: #1abc9c;
      color: #fff;
      border-color: #fff;
    }
  }
  .container:last-child {
    border-color: transparent;
  }
  .Fault li.listPart {
    line-height: 2;
    height: auto;
    padding: 20px 0;
  }
  .faultSub li.listPart {
    line-height: 2;
    height: 90px;
    padding: 20px;
    word-break: break-word;
  }
}
</style>
<style lang="scss">
#questionFault {
  .uploadImg-box {
    display: flex;
    flex-direction: row !important;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px !important;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// questionFault.vue?6913154c